var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-filter-advanced-group',{attrs:{"title":"Categories","count":_vm.count}},[_c('core-filter-input-suggest',{attrs:{"placeholder":"Start typing a category...","has-require":true,"toggle":true,"field":"category_name","filter":_vm.value('categories'),"api":"categories/suggest","data":"categories"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }